module.exports = __webpack_public_path__ + "img/001.2584cfa4.png";